import { render } from "./AdminCreditPurchases.vue?vue&type=template&id=17fd8d51&scoped=true"
import script from "./AdminCreditPurchases.vue?vue&type=script&lang=js"
export * from "./AdminCreditPurchases.vue?vue&type=script&lang=js"

import "./AdminCreditPurchases.vue?vue&type=style&index=0&id=17fd8d51&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17fd8d51"]])

export default __exports__